import { render, staticRenderFns } from "./Up.vue?vue&type=template&id=db4641e6&scoped=true&"
import script from "./Up.vue?vue&type=script&lang=js&"
export * from "./Up.vue?vue&type=script&lang=js&"
import style0 from "./Up.vue?vue&type=style&index=0&id=db4641e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4641e6",
  null
  
)

export default component.exports